import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

Vue.mixin({
  data () {
    return {
      refreshing: false,
      registration: null,
      serviceWorker: null,
      updateExists: false,
      deferredPrompt: {},
      isOnline: true,
      prevIsOnline: true
    }
  },
  created () {
    navigator.onLine ? this.isOnline = true : this.isOnline = false
    this.prevIsOnline = this.isOnline
    // document.addEventListener('swUpdated', this.updateAvailable, { once: true })
    document.addEventListener('swUpdated', this.updateAvailable)
    document.addEventListener('swRegistered', this.swRegistered)
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (this.refreshing) {
        return
      }
      this.refreshing = true
      window.location.reload()
    })
  },
  async mounted () {
    window.addEventListener('beforeinstallprompt', this.beforeInstallPrompt)
    window.addEventListener('appinstalled', this.appInstalled)
    window.addEventListener('online', this.appOnline)
    window.addEventListener('offline', this.appOffline)

    if (this.isOnline && this.numberOfflineForms > 0 && this.isSelfMode) {
      console.log('Wait until BFM logs in to submit offline forms.')
    }
  },
  computed: {
    ...mapGetters({
      numberOfflineForms: 'offline/numberForms',
      numberOfflineInvalidForms: 'offline/numberInvalidForms'
    }),
    showSendOfflineFormsPrompt () {
      return false // this.isOnline && !this.updateExists && this.numberOfflineForms > 0 && !this.isSelfMode
    }
  },
  watch: {
    isOnline (online) {
      if (online && !this.prevIsOnline) {
        this.prevIsOnline = this.isOnline
        const alertData = {
          variant: 'success',
          message: 'Online',
          alerts: ['BETS-e is now operating online.']
        }
        this.setPageAlertInformation(alertData)
      } else if (!online && this.prevIsOnline) {
        this.prevIsOnline = this.isOnline
        const alertData = {
          variant: 'danger',
          message: 'Offline',
          alerts: [
            'BETS-e has lost internet connection and is now operating offline.',
            'You may continue to perform tests that will be submitted when the app comes online.'
          ]
        }
        this.setPageAlertInformation(alertData)
      }
    },
    deferredPrompt: {
      handler: function (newPrompt) {
        if (newPrompt !== undefined && this.loggedIn) {
          const alertData = {
            variant: 'success',
            message: 'Install App',
            type: 'installapp',
            alerts: ['BETS-e is now available.']
          }
          this.setPageAlertInformation(alertData)
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'clearPageAlertInformation',
      'setLoading',
      'setOverlayMessage'
    ]),
    ...mapActions({
      sendOfflineFormResults: 'forms/sendOfflineFormResults'
    }),
    updateAvailable (event) {
      this.registration = event.detail
      this.updateExists = true
    },
    swRegistered (event) {
      this.serviceWorker = event.detail
    },
    checkForUpdate () {
      if (this.serviceWorker !== null) {
        this.serviceWorker.update()
      }
    },
    refreshApp () {
      this.setOverlayMessage('Updating')
      this.setLoading(true)
      this.updateExists = false
      if (!this.registration || !this.registration.waiting) {
        return
      }
      this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
    },
    appInstalled (event) {
      this.clearPageAlertInformation()
    },
    beforeInstallPrompt (event) {
      // Prevent Chrome >=67 from automatically showing the prompt:
      event.preventDefault()
      this.deferredPrompt = event
    },
    appOnline (event) {
      this.isOnline = true
    },
    appOffline (event) {
      this.isOnline = false
    },
    promptInstall () {
      this.deferredPrompt.prompt()

      this.deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === 'accepted') {
          this.clearPageAlertInformation()
        }

        this.deferredPrompt = null
      })
    }
  }
})
